exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bolt-breakpoint {\n  pointer-events: none; }\n\n.bolt-breakpoint-container {\n  height: 2px; }\n\n.bolt-breakpoint-observation {\n  bottom: 0;\n  left: 0;\n  top: 0; }\n", ""]);

// exports
